import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BasicLayoutComponent } from 'app/common/layouts/basicLayout.component';
import { AuthGuard, PendingChangesGuard, PrepareGuard } from 'app/core/core.module';
import { SharedModule } from 'app/shared/shared.module';
import { BuildAssemblyOverviewComponent } from './build-assembly-overview/build-assembly-overview.component';
import { BuildAssemblyDetailComponent } from './build-assembly-detail/build-assembly-detail.component'


@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        RouterModule.forChild([
            {
                path: 'build-assemblies',
                component: BasicLayoutComponent,
                children: [
                    { path: '', redirectTo: 'overview', pathMatch: 'full' },
                    { path: 'overview', component: BuildAssemblyOverviewComponent, data: { title: 'Build Assemblies' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: ':id', component: BuildAssemblyDetailComponent, data: { title: 'Detail' }, canActivate: [AuthGuard, PrepareGuard], canDeactivate: [PendingChangesGuard] },
                ],
            },
        ]),
    ],
    declarations: [
        BuildAssemblyOverviewComponent,
        BuildAssemblyDetailComponent,
    ]
})
export class BuildAssembliesModule {}
